export default __webpack_public_path__ + "static/media/slide17.3d9ba788.jpg";